import SearchPage from "./SearchPage";

export function SearchPage2(){
    return(
        <SearchPage
        fromMainPage={true}
        page="outer page"
        />
    )
}